export const obtenerArrLimitador = (item, cupos) => {

    let diponibles = item.cupos
    let ocupados = cupos

    let texto = ''

    if (ocupados) {
        texto = (parseInt(diponibles) - parseInt(ocupados)) + ' de ' + diponibles + ' Disponibles'
    } else {
        texto = diponibles + ' Cupos Disponibles'
    }

    let arr = []
    for (let i = 0; i < 10; i++) {
        arr.push(texto)
    }

    return arr

}